/** @format */
const apiURL = process.env.REACT_APP_API_URL;


export default async function getDocs(instance, client, token) {
  const apiUrl =`${apiURL}/admin/document/list`;
  let bodyData = JSON.stringify({
    "InstanceId" : instance,
    "ClientId" : client 
})
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: token,
      },
      body: bodyData
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {

    throw new Error(error);
  }
}
